module.exports = __webpack_public_path__ + "img/josefa.3cb50059.png";